import React from 'react';
import { Card } from '../components/ui/card';
import { Button } from '../components/ui/button';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { Database, Zap, Target, Shield, Globe, TrendingUp } from 'lucide-react';

const HumanDataPage = () => {
  return (
    <>
      <Navbar />
      <div className="min-h-screen bg-[#F9FBF5] pt-20">
        <div className="max-w-7xl mx-auto px-6 py-16">
          {/* Hero */}
          <div className="text-center mb-16">
            <h1 className="text-5xl font-bold text-gray-900 mb-6">
              Human Data Solutions
            </h1>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Power your AI with high-quality human-generated training data from vetted experts
            </p>
          </div>

          {/* Services */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
            <Card className="p-8">
              <Database className="w-12 h-12 text-[#0A3900] mb-4" />
              <h3 className="text-xl font-bold text-gray-900 mb-3">Data Annotation</h3>
              <p className="text-gray-600">
                Expert labeling and annotation for computer vision, NLP, and multimodal models
              </p>
            </Card>

            <Card className="p-8">
              <Zap className="w-12 h-12 text-[#0A3900] mb-4" />
              <h3 className="text-xl font-bold text-gray-900 mb-3">RLHF Training</h3>
              <p className="text-gray-600">
                Reinforcement Learning from Human Feedback to align your AI with human preferences
              </p>
            </Card>

            <Card className="p-8">
              <Target className="w-12 h-12 text-[#0A3900] mb-4" />
              <h3 className="text-xl font-bold text-gray-900 mb-3">Data Collection</h3>
              <p className="text-gray-600">
                Custom data collection from domain experts across various industries
              </p>
            </Card>
          </div>

          {/* Why Duty AI */}
          <div className="bg-gray-50 rounded-2xl p-12 mb-16">
            <h2 className="text-3xl font-bold text-gray-900 text-center mb-12">
              Why Choose Duty AI for Human Data?
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div className="flex items-start gap-4">
                <Shield className="w-6 h-6 text-[#0A3900] mt-1" />
                <div>
                  <h3 className="font-semibold text-gray-900 mb-2">Vetted Experts</h3>
                  <p className="text-gray-600">
                    All contributors pass our rigorous AI interview and verification process
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <Globe className="w-6 h-6 text-[#0A3900] mt-1" />
                <div>
                  <h3 className="font-semibold text-gray-900 mb-2">Global Talent Pool</h3>
                  <p className="text-gray-600">
                    Access 78,500+ experts across 150+ countries and 50+ languages
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <Zap className="w-6 h-6 text-[#0A3900] mt-1" />
                <div>
                  <h3 className="font-semibold text-gray-900 mb-2">Fast Turnaround</h3>
                  <p className="text-gray-600">
                    Scale your data operations with our on-demand workforce
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <TrendingUp className="w-6 h-6 text-[#0A3900] mt-1" />
                <div>
                  <h3 className="font-semibold text-gray-900 mb-2">Quality Assurance</h3>
                  <p className="text-gray-600">
                    Multi-layer quality checks ensure >95% accuracy on all tasks
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Use Cases */}
          <div className="mb-16">
            <h2 className="text-3xl font-bold text-gray-900 text-center mb-12">Use Cases</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              <Card className="p-6">
                <h3 className="font-semibold text-gray-900 mb-2">Large Language Models</h3>
                <p className="text-sm text-gray-600">
                  RLHF training, prompt engineering, response ranking, safety testing
                </p>
              </Card>
              <Card className="p-6">
                <h3 className="font-semibold text-gray-900 mb-2">Computer Vision</h3>
                <p className="text-sm text-gray-600">
                  Image/video annotation, object detection, semantic segmentation
                </p>
              </Card>
              <Card className="p-6">
                <h3 className="font-semibold text-gray-900 mb-2">Speech & Audio</h3>
                <p className="text-sm text-gray-600">
                  Transcription, speaker identification, audio quality assessment
                </p>
              </Card>
            </div>
          </div>

          {/* CTA */}
          <div className="bg-[#082900] rounded-2xl p-12 text-center text-white">
            <h2 className="text-3xl font-bold mb-4">Ready to Get Started?</h2>
            <p className="text-lg mb-8 opacity-90">
              Contact our team to discuss your human data needs
            </p>
            <Button
              size="lg"
              variant="secondary"
              onClick={() => window.location.href = '/contact'}
            >
              Get in Touch
            </Button>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default HumanDataPage;